import { Box, styled } from '@mui/material';

export const ResourceSelectorContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 0 16px !important;
  height: 50vh;
`;

export const StyledContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
